import React from "react";
import { getSocialLinks, SocialSettings } from "./menuUtils";
import { FacebookIcon, InstagramIcon, LinkedInIcon, YouTubeIcon } from "./SocialIcons";

type Props = {
    social: SocialSettings;
    variant: "desktop" | "mobile";
    onLinkClick?: () => void;
};

const SOCIAL_ICONS = {
    instagram: InstagramIcon,
    youtube: YouTubeIcon,
    facebook: FacebookIcon,
    linkedin: LinkedInIcon,
} as const;

export function SocialFooter({ social, variant, onLinkClick }: Props) {
    const links = getSocialLinks(social);

    if (links.length === 0) {
        return null;
    }

    if (variant === "desktop") {
        return (
            <div className="side-header-menu__social b_large_light">
                {links.map((link, index) => (
                    <React.Fragment key={link.key}>
                        {index > 0 && <span aria-hidden="true">|</span>}
                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                            {link.label}
                        </a>
                    </React.Fragment>
                ))}
            </div>
        );
    }

    return (
        <div className="side-header-menu__social-icons">
            {links.map((link) => {
                const Icon = SOCIAL_ICONS[link.key as keyof typeof SOCIAL_ICONS];
                return (
                    <a
                        key={link.key}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={link.label}
                        onClick={onLinkClick}
                    >
                        <Icon />
                    </a>
                );
            })}
        </div>
    );
}
